import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, HostBinding, Input, OnChanges } from '@angular/core';
import { HrefComponent } from '@df/ui/common/href/href.component';
import { LineHeightByComponent } from '@df/ui/common/line-height-by.component';

/**
 * Similar to swatch but presents checkbox icon instead
 */
@Component({
    selector: 'icon-label',
    templateUrl: './icon-label.html',
    standalone: true,
    imports: [HrefComponent, NgClass, LineHeightByComponent],
    styleUrls: ['./icon-label.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class IconLabelComponent implements OnChanges {
    @Input()
    icon?: string;

    @Input()
    textClass = 'p2';

    @Input()
    offset = 2;

    @Input()
    iconLink?: string;

    @Input()
    @HostBinding('class._fullWidth')
    fullWidth?: boolean;

    ngOnChanges(changes) {
        // normalize icon name in case we pass icon-something from icms
        if (changes.icon && this.icon) {
            this.icon = this.icon.replace(/^icon-/, '');
        }
    }
}
